import React, {
  useState,
  useContext,
  createContext,
  useMemo,
} from 'react'

const defaultContextStructure = {
  showOosProducts: false,
  shouldShowOosProducts: () => false,
  outOfStockItems: [],
  setOutOfStockItems: () => [],
  showOosNotifyForm: false,
  shouldShowOosNotifyForm: () => false,
  showCannotShipProducts: false,
  shouldShowCannotShipProducts: () => false,
  cannotShipItems: { source: 'default', state: '', items: [] },
  setCannotShipItems: () => [],
}

const PopUpContext = createContext(defaultContextStructure)

const PopUpProvider = props => {
  const { children } = props
  const [showOosProducts, shouldShowOosProducts] = useState(false)
  const [outOfStockItems, setOutOfStockItems] = useState([])
  const [showOosNotifyForm, shouldShowOosNotifyForm] = useState(false)

  const [showCannotShipProducts, shouldShowCannotShipProducts] = useState(false)
  const [cannotShipItems, setCannotShipItems] = useState(defaultContextStructure.cannotShipItems)

  const contextValue = useMemo(
    () => ({
      showOosProducts,
      shouldShowOosProducts,
      outOfStockItems,
      setOutOfStockItems,
      showOosNotifyForm,
      shouldShowOosNotifyForm,
      showCannotShipProducts,
      shouldShowCannotShipProducts,
      cannotShipItems,
      setCannotShipItems,
    }),
    [
      showOosProducts,
      shouldShowOosProducts,
      outOfStockItems,
      setOutOfStockItems,
      showOosNotifyForm,
      shouldShowOosNotifyForm,
      showCannotShipProducts,
      shouldShowCannotShipProducts,
      cannotShipItems,
      setCannotShipItems,
    ],
  )

  return (
    <PopUpContext.Provider value={contextValue}>
      {children}
    </PopUpContext.Provider>
  )
}

export const usePopUpContext = () => useContext(PopUpContext)

export default PopUpProvider
